import { render, staticRenderFns } from "./CallSettingsLayout.vue?vue&type=template&id=6f928034&scoped=true"
import script from "./CallSettingsLayout.vue?vue&type=script&lang=js"
export * from "./CallSettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./CallSettingsLayout.vue?vue&type=style&index=0&id=6f928034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f928034",
  null
  
)

export default component.exports